<template>
  <div class="button-add-section">
    <button
      type="button"
      @click="$emit('click', $event)"
      :disabled="buttonDisabled"
    >
      <span>+</span>
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: "CertButtonAddSection",
  props: {
    buttonText: String,
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.mtm {
  button:not(:disabled):hover,
  button:not(:disabled):focus {
    color: $exMtm;
  }
}
button {
  border: 0;
  border-top: 1px solid $borderLightGray;
  border-bottom: 1px solid $borderLightGray;
  height: 50px;
  line-height: 50px;
  color: $formDarkBlue;
  @include fontSize(14px);
  font-weight: bold;
  background-color: #fff;
  width: 100%;
  cursor: pointer;
  text-align: left;
}

.rtl button {
  text-align: right;
}

button:not(:disabled):hover,
button:not(:disabled):focus {
  color: $exBlue;
}
</style>
